import React, { useState, useEffect, useContext, useCallback, useRef } from "react";
import PageTitle from "../../Components/PageTitle";
import axios from "axios";
import Swal from "sweetalert2";
import { ConfigContext } from "../../Context/ConfigContext";
import { ContentLoader, NoRecords } from "../../Components/Shimmer";
import Select from "react-select";
import { NavLink, useParams } from "react-router-dom";
import { DateFormaterMonth } from "../../Components/GlobalFunctions";
import { handleDownloadOptions } from "../../Components/ExportData";





const PendingRequest = () => {
    const { apiURL, apiHeaderJson, apiHeaderFile, user_profile_id } = useContext(ConfigContext);
    const [selectOption, setSelectOption] = useState(null);
    const [projectData, setProjectData] = useState([]);
    const { project_id } = useParams()
    const [loadingList, setLoadingList] = useState(false)

    const options = [
        { value: 'pending', label: "Pending" },
        { value: 'approved', label: 'Approved' },
        { value: 'rejected', label: 'Rejected' }
    ];



    const handleSelectStatus = (selectedOption) => {
        setSelectOption(selectedOption ? selectedOption.value : '');
    };




    const Labels = (status) => {
        if (status === 0) {
            return "Pending"
        }
        else if (status === 1) {
            return "Approved"
        }
        else if (status === 2) {
            return "Rejected"
        }
        else if (status === 3) {
            return "Revise & Resubmit"
        }
        else if (status === 4) {
            return "In-Clearence "
        }
    }
    const Classes = (status) => {
        if (status === 0) {
            return "badge bg-warning-subtle text-warning"
        }
        else if (status === 1) {
            return "badge bg-success-subtle text-success"
        }
        else if (status === 2) {
            return "badge bg-danger-subtle text-danger"
        }
        else if (status === 3) {
            return "badge bg-info-subtle text-info"
        }
        else if (status === 4) {
            return "badge bg-secondary-subtle text-secondary"
        }
    }


    // const handlePrev = () => {
    //     if (prev) {
    //         setPage((prevPage) => prevPage - 1);
    //     }
    // };

    // const handleNext = () => {
    //     if (next) {
    //         setPage((prevPage) => prevPage + 1);
    //     }
    // };
    // const handleChange = (e) => {
    //     setPage(parseInt(e.target.value, 10));
    // };

    const getPendingProjects = async () => {
        try {
            setLoadingList(true)
            const headers = apiHeaderJson;

            const response = await axios.get(`${apiURL}api/GetDashboardForConsultant`,
                {
                    params: { consultant_id: user_profile_id },
                    headers,
                }
            );
            setLoadingList(false)
            const filteredData = response.data?.data?.tabs?.projects_requests.filter(row => row.request_status === 0)
            setProjectData(filteredData);


        } catch (error) {
            console.log(error);

        }
        finally {
            setLoadingList(false)
        }
    }

    const handleDownload = (downloadType) => {
        const endpoint = `api/GetDashboardForConsultant`;
        const params = {
            consultant_id: user_profile_id
        };

        const columns = [
            { header: "Project Name", width: 30 },
            { header: "Item Name", width: 35 },
            { header: "Submittal Description", width: 27 },
            { header: "Brief Description", width: 30 },
            { header: "Status", width: 25 },
        ];

        const mapRow = (data) => ({
            "Project Name": data?.project_title ?? '-',
            "Item Name": data?.item_name ?? '-',
            "Submittal Description": data?.submittal_description ?? "-",
            "Brief Description": data?.request_brief_description ?? "-",
            "Status": data?.consultant_given_status === 1 ? Labels(data?.consultant_given_status) : Labels(data?.request_status) ?? "-",
        });

        // Modify the response handling in handleDownloadOptions to get the correct data path
        const responseHandler = (response) => response.data?.data?.tabs?.projects_requests || [];

        handleDownloadOptions(endpoint, params, columns, mapRow, downloadType, apiURL, apiHeaderJson, responseHandler);
    };

    useEffect(() => {
        getPendingProjects()
    }, [])
    return (
        <div className='main-content'>
            <div className='page-content'>
                {
                    loadingList ? <ContentLoader /> :
                        <>
                            <div className="container-fluid">
                                <PageTitle title={`All Pending Request`} primary={`Home`} />
                                <div className="col-md-12">
                                    <div className="card">
                                        <div
                                            className="card-header align-items-center d-flex justify-content-between"
                                            style={{
                                                background: "#000000",
                                            }}
                                        >
                                            <h4 className="card-title mb-0 flex-grow-1 text-white">Pending Request List</h4>


                                        </div>
                                        <div className="card-header pt-0 pb-0" style={{ border: "none" }}>
                                            <div className="row align-items-center py-4 g-3">
                                                {/* Status Select - takes 4 columns on md screens, full width on mobile */}
                                                {/* <div className="col-md-4 col-12">
                                                    <Select
                                                        options={options}
                                                        value={selectOption ? options.find(option => option.value === selectOption) : null}
                                                        onChange={handleSelectStatus}
                                                        placeholder="Please Select Status"
                                                    />
                                                </div> */}
                                                <div className="col-md-9"></div>


                                                {/* Download Report Dropdown - takes 3 columns on md screens, full width on mobile */}
                                                <div className="col-md-3 col-12">
                                                    <div className="dropdown d-flex justify-content-md-end">
                                                        <button
                                                            type="button"
                                                            className="btn btn-light btn-label waves-effect waves-light"
                                                            id="dropdownMenuLink4"
                                                            data-bs-toggle="dropdown"
                                                            aria-expanded="true"
                                                        >
                                                            <i className="ri-download-2-line label-icon align-middle fs-16 me-2" />
                                                            Download Report
                                                        </button>
                                                        <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuLink4">
                                                            <li><a className="dropdown-item" style={{ cursor: "pointer" }} onClick={() => handleDownload('print')}><i className="ri-printer-line me-2 align-middle text-muted" />Print</a>
                                                            </li>
                                                            <li><a className="dropdown-item" style={{ cursor: "pointer" }} onClick={() => handleDownload('pdf')}><i className="ri-file-pdf-line me-2 align-middle text-muted" />PDF</a>
                                                                <li><a className="dropdown-item" style={{ cursor: "pointer" }} onClick={() => handleDownload('excel')}><i className="ri-file-excel-2-line me-2 align-middle text-muted" />Excel</a>
                                                                </li>

                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="card-body pt-0">
                                                <div className="table-responsive table-card">
                                                    <table
                                                        className={`table table-bordered table-stripped mb-0`}
                                                    >
                                                        <thead className="table-light">
                                                            <tr>
                                                                <th className="text-center" width="28%">Project Name</th>
                                                                <th className="text-center" width="10%">Item Name</th>
                                                                <th className="text-center" width="20%">Submittal Description</th>
                                                                <th className="text-center" width="20%">Brief Description</th>
                                                                <th className="text-center" width="10%">Status</th>
                                                            </tr>
                                                        </thead>
                                                        {projectData.length !== 0 ? (
                                                            <tbody>
                                                                {
                                                                    projectData.map((row) => (
                                                                        <tr key={row.category_id}>
                                                                            <td className="text-center">
                                                                                <NavLink to={`/ProjectProfile/${row.project_id}`}>{row?.project_title ?? '-'}</NavLink>
                                                                            </td>
                                                                            <td className="text-center">{row?.item_name ?? '-'}</td>
                                                                            <td className="text-center">{row?.submittal_description}</td>
                                                                            <td className="text-center">{row?.request_brief_description}</td>
                                                                            {
                                                                                <td className="text-center"><span className={Classes(row.request_status)}>{Labels(row.request_status)}</span></td>
                                                                            }

                                                                            {/* <td className="text-center">Architecture</td> */}



                                                                        </tr>
                                                                    ))}
                                                            </tbody>
                                                        ) : (
                                                            <tbody>
                                                                <tr>
                                                                    <td colSpan="7">
                                                                        <NoRecords />
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        )}
                                                        {/* <tfoot className="table-light">
                                                    
                                                    <th colSpan={6}>
                                                        <div className="d-flex justify-content-between">
                                                            <button
                                                                disabled={
                                                                    prev === false && loadingList === false
                                                                        ? true
                                                                        : false
                                                                }
                                                                type="button"
                                                                onClick={() => handlePrev()}
                                                                className={`btn btn-warning btn-label waves-effect waves-light`}
                                                            >
                                                                <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" />{" "}
                                                                Previous
                                                            </button>
                                                            <div
                                                                className="col-md-4"
                                                                style={{
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                }}
                                                            >
                                                                {
                                                                    <small>
                                                                        Total Records: {totalRecords} | Total
                                                                        Pages: {totalPages} | Current Page:{" "}
                                                                        {page}
                                                                    </small>
                                                                }
                                                            </div>
                                                            <div className="col-md-2">
                                                                <select
                                                                    className="form-select"
                                                                    onChange={(e) => handleChange(e)}
                                                                >
                                                                    {Array.from(
                                                                        { length: totalPages },
                                                                        (_, i) => (
                                                                            <option
                                                                                key={i + 1}
                                                                                selected={page === i + 1}
                                                                                value={i + 1}
                                                                            >
                                                                                {i + 1}
                                                                            </option>
                                                                        )
                                                                    )}
                                                                </select>
                                                            </div>
                                                            <button
                                                                disabled={
                                                                    next === false && loadingList === false
                                                                        ? true
                                                                        : false
                                                                }
                                                                type="button"
                                                                onClick={() => handleNext()}
                                                                className={`btn btn-primary btn-label waves-effect right waves-light`}
                                                            >
                                                                <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" />{" "}
                                                                Next
                                                            </button>
                                                        </div>
                                                    </th>
                                                    >
                                                     */}
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </>
                }
            </div>
        </div>
    )
}

export default PendingRequest